import * as echarts from 'echarts'

/* global ResizeObserver */

/**
 * Initialize an ECharts instance on the given container element.
 * Automatically observes container resizes so the chart adapts
 * when its parent layout settles after first render.
 */
export const safeChartInit = (
  element: HTMLElement,
  theme?: string | object,
  opts?: echarts.EChartsInitOpts
): echarts.ECharts => {
  const chart = echarts.init(element, theme, opts)

  const observer = new ResizeObserver(() => {
    if (!chart.isDisposed()) {
      chart.resize()
    }
  })
  observer.observe(element)

  const originalDispose = chart.dispose.bind(chart)
  chart.dispose = () => {
    observer.disconnect()
    originalDispose()
  }

  return chart
}
